import { migrateStoredTagSelectionsToIds } from '@/state/tagFilterState';
import { migrateRetiredLocalStorageKeys } from '@/utils/browserStorage';
import { listenForModulePreloadErrors } from '@/utils/moduleFetchRecovery';
import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './polyfills';
import { initSentryInBrowser } from './sentry';

initSentryInBrowser();
listenForModulePreloadErrors();
migrateRetiredLocalStorageKeys();
migrateStoredTagSelectionsToIds();

const container = document.getElementById('root');
if (!container) {
    throw new Error('Root element #root not found');
}

const root = createRoot(container);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
